<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{grayMode: isGrayMode}">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div class="d2-theme-header" flex-box="0">
        <div v-if="isShowHeaderToggleAside" class="toggle-aside-btn" @click="handleToggleAside">
          <d2-icon name="bars"/>
        </div>
        <div class="logo-group" ><!--:style="{width: isMenuAsideCollapse ? asideWidthCollapse : asideWidth}"-->
          <!--<img v-if="isMenuAsideCollapse" :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/icon-only.png`">
          <img v-else :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/all.png`">-->
          <div class="logo-title">{{logoTitle}}</div>
          <!--<img :src="`${$baseUrl}image/guoguan/guoguan-logo.png`">-->
        </div>

        <!--<d2-menu-header/>-->
        <!-- 顶栏右侧 -->
        <div class="d2-header-right">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <!--<d2-header-error-log/>-->
          <!--<d2-header-help/>-->
          <!--<header-bigscreen/>--><!-- 大屏幕入口按钮 -->
          <!-- <d2-header-fullscreen/> -->
          <d2-header-theme/>
          <!--<d2-header-user/>-->
          <span class=".theme-dark-blue .el-dropdown" style="color:#8fbadd; margin: 0 25px;">您好，{{ username }} </span>
          <!--<d2-header-user-appstore/>-->
          <span class="layout" @click="showLogoutConfirm"> 退出 </span>
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{width: isMenuAsideCollapse ? asideWidthCollapse : asideWidth}">
          <d2-menu-side/>
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex="dir:top">
          <div class="d2-theme-container-main-header" flex-box="0">
            <!--<d2-tabs :isShowTabsToggleAside="false" class="d2-tabs-d2admin"/>-->
            <d2-breadcrumb v-if="isShowBreadcrumb"/>
          </div>
          <div class="d2-theme-container-main-body" flex-box="1">
            <transition name="fade-transverse">
              <!--<keep-alive :include="d2adminKeepAliveInclude">-->
                <router-view/>
              <!--</keep-alive>-->
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import setting from '@/setting.js'
import ResizeMixin from '@/layout/mixin/ResizeHandler'
import util from '@/libs/util.js'

export default {
  name: 'd2-layout-header-aside',
  components: {
    'd2-menu-side': () => import('./components/menu-side'),
    'd2-menu-header': () => import('./components/menu-header'),
    'd2-tabs': () => import('./components/tabs'),
    'd2-breadcrumb': () => import('./components/breadcrumb'),
    'd2-header-fullscreen': () => import('./components/header-fullscreen'),
    'd2-header-theme': () => import('./components/header-theme'),
    'd2-header-user': () => import('./components/header-user'),
    'd2-header-help': () => import('./components/header-help'),
    'd2-header-user-appstore': () => import('./components/header-user-appstore'),
      //'d2-header-error-log': () => import('./components/header-error-log')
    'header-bigscreen': () => import('./components/header-bigscreen')
  },
  mixins: [ResizeMixin],
  data () {
    return {
      username: util.cookies.get('username'), // 用户名
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      // 是否显示tab标签页的切换侧边栏菜单按钮
      isShowHeaderToggleAside: true,
      // 面包屑
      isShowBreadcrumb: setting.layout.isShowBreadcrumb,
      // Logo文字内容
      logoTitle: process.env.VUE_APP_TITLE
    }
  },
  computed: {
    ...mapState({
      isGrayMode: state => state.d2admin.isGrayMode,
      pageOpenedList: state => state.d2admin.pageOpenedList,
      isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse
    }),
    ...mapGetters([
      'd2adminThemeActiveSetting',
      'd2adminKeepAliveInclude'
    ]),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup () {
      return {
        ...this.d2adminThemeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.d2adminThemeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  methods: {

     
    ...mapMutations([
      'd2adminMenuAsideCollapseToggle'
    ]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside () {
      this.d2adminMenuAsideCollapseToggle()
    },
     // 显示确认退出的对话框
    showLogoutConfirm() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });          
      });
    },
    
    // 执行退出逻辑
    logout() {
      // 清除相关 cookies
      util.cookies.remove('username');
      util.cookies.remove('token');
      util.cookies.remove('refreshToken');

      console.log("Cookies after logout:", document.cookie); // 调试信息，检查cookies是否已删除

      // 直接跳转到登录页面，不进行 token 刷新检查
      this.$router.push({
        path: '/login',
        query: { redirect: this.$route.fullPath } // 可选：记录从哪个页面跳转过来的，以便登录后可以返回原页面
      }).then(() => {
        window.location.reload(); // 在路由跳转完成后刷新页面
      });
    }

  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';

/* 该布局下，tab标签页边框去除 */
.d2-tabs-d2admin .el-tabs--card>.el-tabs__header .el-tabs__nav{
  border-left: none;
}
/* logo标题调整 */
.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-header .logo-group .logo-title{
    height: 50px;
    line-height: 50px;
    font-size: 22px;
}

.layout{
  padding-right: 20px;
  cursor: pointer;
  font-size: 15px;
}

</style>

